import { fromJS } from 'immutable'
import { Actions } from './data-cycles.actions'
import * as DataCyclesTypes from './data-cycles.types'

export const initialState = fromJS<any>({
  list: {
    isLoading: false,
    shouldReload: false,
    data: [],
    queryParams: {
      page_size: 20,
      page: 1,
    },
    total: 0,
    results: 0,
  },
  createDataCycle: {
    isLoading: false,
    validationErrors: {},
    data: {},
  },
  updateDataCycle: {
    isLoading: false,
    validationErrors: {},
    data: {},
  },
  switchDataCycle: {
    isLoading: false,
    isStatsLoading: false,
    validationErrors: {},
    stats: [],
    data: {},
  },
})

export function dataCyclesReducer(state = initialState, action: Actions) {
  switch (action.type) {
    case DataCyclesTypes.UPDATE_DATA_CYCLE_REQUEST: {
      return state.setIn(['updateDataCycle', 'isLoading'], true)
    }

    case DataCyclesTypes.UPDATE_DATA_CYCLE_SUCCESS: {
      return state.setIn(['updateDataCycle', 'isLoading'], false)
    }

    case DataCyclesTypes.UPDATE_DATA_CYCLE_FAILURE: {
      return state.setIn(['updateDataCycle', 'isLoading'], false)
    }

    case DataCyclesTypes.CREATE_DATA_CYCLE_REQUEST: {
      return state.setIn(['createDataCycle', 'isLoading'], true)
    }

    case DataCyclesTypes.CREATE_DATA_CYCLE_SUCCESS: {
      return state.setIn(['createDataCycle', 'isLoading'], false)
    }

    case DataCyclesTypes.CREATE_DATA_CYCLE_FAILURE: {
      return state.setIn(['createDataCycle', 'isLoading'], false)
    }

    case DataCyclesTypes.DELETE_DATA_CYCLE_REQUEST: {
      return state
    }

    case DataCyclesTypes.DELETE_DATA_CYCLE_SUCCESS: {
      return state.setIn(['list', 'shouldReload'], true)
    }
    case DataCyclesTypes.DELETE_DATA_CYCLE_FAILURE: {
      return state
    }

    case DataCyclesTypes.FETCH_DATA_CYCLES_REQUEST: {
      return state
        .setIn(['list', 'isLoading'], true)
        .setIn(['list', 'shouldReload'], false)
    }

    case DataCyclesTypes.FETCH_DATA_CYCLES_SUCCESS: {
      return state
        .setIn(['list', 'isLoading'], false)
        .setIn(['list', 'data'], fromJS(action.payload))
        .setIn(['list', 'total'], fromJS(action.total))
        .setIn(['list', 'results'], fromJS(action.results))
    }

    case DataCyclesTypes.FETCH_DATA_CYCLES_FAILURE: {
      return state.setIn(['list', 'isLoading'], false)
    }

    case DataCyclesTypes.FETCH_DATA_CYCLE_REQUEST: {
      return state.setIn(['updateDataCycle', 'isLoading'], true)
    }

    case DataCyclesTypes.FETCH_DATA_CYCLE_SUCCESS: {
      return state
        .setIn(['updateDataCycle', 'isLoading'], false)
        .setIn(['updateDataCycle', 'data'], fromJS(action.payload))
    }

    case DataCyclesTypes.FETCH_DATA_CYCLE_FAILURE: {
      return state.setIn(['updateDataCycle', 'isLoading'], false)
    }

    case DataCyclesTypes.FETCH_BATCH_TASK_STATUS_REQUEST: {
      return state.setIn(['switchDataCycle', 'isBatchStatusLoading'], true)
    }

    case DataCyclesTypes.FETCH_BATCH_TASK_STATUS_SUCCESS: {
      return state
        .setIn(['switchDataCycle', 'isBatchStatusLoading'], false)
        .setIn(['switchDataCycle', 'stats'], fromJS(action.payload))
    }

    case DataCyclesTypes.FETCH_BATCH_TASK_STATUS_FAILURE: {
      return state.setIn(['switchDataCycle', 'isBatchStatusLoading'], false)
    }

    case DataCyclesTypes.FETCH_INIT_SWITCH_STATS_REQUEST: {
      return state.setIn(['switchDataCycle', 'isStatsLoading'], true)
    }

    case DataCyclesTypes.FETCH_INIT_SWITCH_STATS_SUCCESS: {
      return state
        .setIn(['switchDataCycle', 'stats'], fromJS(action.payload))
        .setIn(['switchDataCycle', 'isStatsLoading'], false)
    }

    case DataCyclesTypes.FETCH_INIT_SWITCH_STATS_FAILURE: {
      return state.setIn(['switchDataCycle', 'isStatsLoading'], false)
    }

    case DataCyclesTypes.FETCH_DATA_CYCLE_STATS_REQUEST: {
      return state.setIn(['switchDataCycle', 'isStatsLoading'], true)
    }

    case DataCyclesTypes.FETCH_DATA_CYCLE_STATS_SUCCESS: {
      return state
        .setIn(['switchDataCycle', 'isStatsLoading'], false)
        .setIn(
          ['switchDataCycle', 'data'],
          state
            .getIn(['switchDataCycle', 'data'])
            .merge(fromJS(action.payload)),
        )
    }

    case DataCyclesTypes.FETCH_DATA_CYCLE_STATS_FAILURE: {
      return state.setIn(['switchDataCycle', 'isStatsLoading'], false)
    }

    case DataCyclesTypes.SWITCH_DATA_CYCLE_REQUEST: {
      return state.setIn(['switchDataCycle', 'isLoading'], true)
    }
    case DataCyclesTypes.SWITCH_DATA_CYCLE_SUCCESS: {
      return state.setIn(['switchDataCycle', 'isLoading'], false)
    }
    case DataCyclesTypes.SWITCH_DATA_CYCLE_FAILURE: {
      return state.setIn(['switchDataCycle', 'isLoading'], false)
    }

    case DataCyclesTypes.STOP_DATA_CYCLE_SWITCHING_REQUEST: {
      return state.setIn(['switchDataCycle', 'isLoading'], true)
    }
    case DataCyclesTypes.STOP_DATA_CYCLE_SWITCHING_SUCCESS: {
      return state.setIn(['switchDataCycle', 'isLoading'], false)
    }
    case DataCyclesTypes.STOP_DATA_CYCLE_SWITCHING_FAILURE: {
      return state.setIn(['switchDataCycle', 'isLoading'], false)
    }

    case DataCyclesTypes.UPDATE_FIELD:
      let fields = []

      if (action.path === '') {
        fields = action.field.split('.')
      } else {
        fields = action.path.split('.').concat(action.field.split('.'))
      }
      const value = action.value

      if (fields.length === 1) {
        return state.set(fields[0], fromJS(value))
      }
      return state.setIn(fields, fromJS(value))
    case DataCyclesTypes.SET_DEFAULT_DATA:
      const path = action.path || ''
      return state.setIn(path.split('.'), initialState.getIn(path.split('.')))

    default:
      return state
  }
}
